<template>
  <div class="service-enter">
    <div class="service-list">
      <div class="service-item" v-for="item in serviceQrcodeList" :key="item.serviceId" @click="goto(item.serviceType, item.serviceId)">
        <img :src="item.picUrl" :alt="item.serviceName">
        <p>{{item.serviceName}}</p>
      </div>
    </div>
    <div class="ios-bottom"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import redirectToService from '@/utils/redirectTo';

export default {
  props: {
    serviceQrcodeList: {
      type: Array,
      default: [],
    },
  },
  computed: {
    ...mapGetters(['token', 'currentParkId', 'parkServiceList']),
  },
  methods: {
    ...mapMutations(['change_parkServiceList']),
    getService() {  // 获取八大服务
      return new Promise(resolve=>{
        this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
          parkId: this.currentParkId,
        }).then((response) => {
          const res = response.data;
          if (res.resCode === '10000') {
            this.serviceList = res.resData.pageList;
            let arr = [];
            this.serviceList.forEach((val) => {
              arr.push({
                serviceFlag: val.serviceFlag,
                serviceName: val.serviceName,
                serviceId: val.serviceId,
                children: val.childrenList
              })
            });
            this.change_parkServiceList(arr);
            resolve()
          }
        });
      })
    },
    goto (type, serviceId){
      if(this.token == ''){
        this.$root.eventHub.$emit('login', this.$route.fullPath);
        return
      }
      let serviceFlag = 1;
      this.parkServiceList.forEach((val) => {
        if(val.children.length){
          val.children.forEach((v)=>{
            if(v.serviceId == serviceId){
              serviceFlag = val.serviceFlag;
            }
          })
        }
      })
      let redirectPath = redirectToService(type, serviceId, serviceFlag);
      this.$router.push({path: redirectPath, query:{bindQr:1} });
    },
  },
  created() {
    if(this.parkServiceList.length == 0){
      this.getService()
    }
  },
};
</script>

<style lang="scss" scoped>
.show-tip{
  .service-enter {
    .service-list {
      width: 100%;
    }
  }
}
.dtap{
  .service-enter {
    .service-list {
      .service-item {
        margin-left: 0px;
      }
    }
  }
}
@media screen and (max-width:330px){
 .show-tip{
    .service-enter {
      .service-list {
        .service-item {
          margin-left: 0px;
        }
      }
    }
  }
}
.service-enter {
  width: 100%;
  overflow-x:scroll;
  overflow-y:hidden;
  padding-top: 18px;
  .service-list {
    width: max-content;
    .service-item {
      width: 100px;
      float: left;
      background: #fff;
      // margin-right: 0.1rem;
      margin-left: 0.4rem;
      text-align: center;
      font-size: 14px;
      padding-bottom: 18px;
      img {
        height: 36px;
        width: 36px;
      }
    }
  }
  .ios-bottom{
    height: 80px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/QrcodeQuickEntry.vue